<template lang="pug">
  .agency-list-toolbar.my-3
    .row.px-3
      .col.col-md-3.col-lg-2
        PhoDatePicker(
          v-model="lazyValue.createdDate"
          clearable
          range
          :label="$t($lang.date.DATE)"
          :placeholder="$t($lang.app.CHOOSE)"
          @input="onFilterChanged"
        )
      .col.col-md-3.col-lg-2
        Agencies(
          v-model="lazyValue.agencyIds"
          :content-types="agencyContentTypes"
          :tab-name="tabName"
          @input="onFilterChanged"
        )
      .col.col-md-3.col-lg-2
        AgencyCategory(
          v-model="lazyValue.agencyCategories"
          :content-types="contentTypes"
          :tab-name="tabName"
          :agency-ids="lazyValue.agencyIds"
          :selected-tab="selectedTab"
          @input="onFilterChanged"
        )
      .col.col-md-3.col-lg-2
        AgencyNewsType(
          v-model="lazyValue.agencyNewsType"
          :isDisabled="isArchiveTab"
          @input="onFilterChanged"
        )
      .col.col-md-3.col-lg-2(v-if="isArchiveTab")
        v-autocomplete(
          v-model="lazyValue.isApproved"
          dense
          clearable
          outlined
          attach
          item-value='value'
          item-text='text'
          :items='translatedStatusList'
          :label='$t($lang.status.APPROVE_STATUS)'
          :placeholder="$t($lang.status.SELECT_STATUS)"
          @change="onFilterChanged"
        )
      .col.col-md-3.col-lg-2(v-if="isArchiveTab")
        UserListOfHavingAgencyArchive(
          v-model="lazyValue.users"
          @input="onFilterChanged"
        )
      .col.col-md-3.col-lg-2
        v-switch(
          v-model="lazyValue.showUsedContent"
          :label="$t($lang.agency.USED_CONTENT)"
          @change="onFilterChanged"
        )
      .col.col-md-3.col-lg-2
        v-switch(
          v-model="lazyValue.showInappropriateContent"
          :label="$t($lang.agency.INAPPROPRIATE_CONTENT)"
          @change="onFilterChanged"
        )
    .list-page-search-area
      PhoTextField(
        v-model="lazyValue.search"
        dense
        prepend-icon="search"
        :outlined="false"
        :label="$t($lang.app.SEARCH)"
        @input="onFilterChanged"
      )
</template>

<script>

import { computed, watch } from 'vue';
import { useTwoWayBinding } from '@/helpers/misc/binding';
import { useDynamicTranslations } from '@/helpers/misc/useDynamicTranslations';
import { PhoDatePicker, PhoTextField } from '@/components/misc/form';
import MainCategories from '@/components/category/MainCategories.vue';
import UserListOfHavingAgencyArchive from './UserListOfHavingAgencyArchive.vue';
import AgencyCategory from './AgencyCategory.vue';
import Agencies from './Agencies.vue';
import AgencyNewsType from './AgencyNewsType.vue';
import { agencyTabItems } from './constants';

export default {
  name: 'AgencyListToolbar',
  components: {
    AgencyNewsType,
    PhoDatePicker,
    PhoTextField,
    MainCategories,
    UserListOfHavingAgencyArchive,
    Agencies,
    AgencyCategory,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
      }),
    },
    selectedTab: {
      type: Number,
      required: true,
    },
    contentTypes: {
      type: Array,
      required: true,
    },
    tabName: {
      type: String,
    },
    agencyContentTypes: {
      type: Array,
      required: true,
    },
  },

  setup(props, { emit }) {
    const { lazyValue, updateValue } = useTwoWayBinding('value', emit, props);
    const isArchiveTab = computed(() => props.selectedTab === agencyTabItems.archive);

    const [translatedStatusList] = useDynamicTranslations([
      {
        value: true,
        langPath: 'agency',
        langKey: 'APPROVED_ARCHIVE',
      },
      {
        value: false,
        langPath: 'agency',
        langKey: 'UNAPPROVED_ARCHIVE',
      },
    ]);

    const onFilterChanged = async () => {
      updateValue(lazyValue.value);
    };

    return {
      translatedStatusList,
      onFilterChanged,
      isArchiveTab,
      lazyValue,
    };
  },
};
</script>
